module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_6005.8d31197d.png";